import { apiRequest } from './client';
import type {
  ConfirmRequest,
  LabDetail,
  LabDraft,
  LabSummary,
  SubmissionDetail,
} from './types';

export async function uploadLab(file: File): Promise<LabDraft> {
  const formData = new FormData();
  formData.append('file', file);
  return apiRequest<LabDraft>('/labs/upload', { method: 'POST', formData });
}

export async function confirmLab(labId: number, payload: ConfirmRequest): Promise<LabDetail> {
  return apiRequest<LabDetail>(`/labs/${labId}/confirm`, { method: 'POST', body: payload });
}

export async function listLabs(): Promise<LabSummary[]> {
  return apiRequest<LabSummary[]>('/labs');
}

export async function getLab(id: number): Promise<LabDetail> {
  return apiRequest<LabDetail>(`/labs/${id}`);
}

export async function getSubmission(date: string): Promise<SubmissionDetail> {
  return apiRequest<SubmissionDetail>(`/labs/submission/${encodeURIComponent(date)}`);
}

export async function getDraft(id: number): Promise<LabDraft> {
  return apiRequest<LabDraft>(`/labs/${id}/draft`);
}

export function labPdfUrl(id: number): string {
  return `/api/v1/labs/${id}/pdf`;
}

export async function deleteLab(id: number): Promise<void> {
  await apiRequest(`/labs/${id}`, { method: 'DELETE' });
}
